export default "__VITE_ASSET__BRnU96vA__"